'use client';

import { DOPLink } from '@/uiComposites/interactive/DOPLink';
import { chevronIcon } from '@/uiIcons/chevronIcon.css';
import { classes } from '@/uiPrimitives/base/classes.helpers';
import { box } from '@/uiPrimitives/layout/box';
import { placement } from '@/uiPrimitives/layout/placement.css';
import { shelf } from '@/uiPrimitives/layout/shelf';
import { icon } from '@/uiPrimitives/media/icon';
import { textBlock, textStyle } from '@/uiPrimitives/typography/text';
import { visiblyHidden } from '@/uiPrimitives/utility/display.css';
import { addTestSelector } from '@/globals/testHelpers/testSelector';
import { usePathname } from 'next/navigation';

export const SubjectsLink = ({
	href,
	text,
	amount,
}: {
	href: string;
	text: string;
	amount: {
		number: number;
		label: string;
	};
}) => {
	const pathname = usePathname();

	const isCurrentSubject = pathname === href;

	return (
		<DOPLink
			data-link-type="subject-link"
			href={href}
			{...addTestSelector(`uiSubOverviewLink-${text}`)}
			className={classes(
				shelf({
					gap: '-1 | small',
					gridTemplateColumns: 'auto minmax(0, 1fr) auto',
					alignItems: 'center',
				}),
				box({
					paddingInlineEnd: '1 | h3',
					backgroundColor: isCurrentSubject ? 'positiveBlue' : 'transparent',
					backgroundColorTransition: '0ms',
					paddingBlock: 'negative 1 | h3',
				}),
				textStyle({
					color: isCurrentSubject ? 'negative' : 'positiveBlue:noVisited',
					capSize: '-1 | small',
				}),
			)}
		>
			<i
				className={classes(
					icon({
						icon: chevronIcon,
						fillTransition: '0ms',
					}),
					isCurrentSubject && visiblyHidden,
					placement({ alignSelf: 'start' }),
				)}
			/>
			<span
				className={classes(
					textBlock({
						textWrap: 'balance',
						colorTransition: '0ms',
					}),
				)}
			>
				{`${text} (${amount.number}\xa0${amount.label})`}
			</span>
			<i
				className={classes(
					icon({
						icon: chevronIcon,
						fillTransition: '0ms',
					}),
					!isCurrentSubject && visiblyHidden,
				)}
			/>
		</DOPLink>
	);
};
